export default __webpack_public_path__ + "static/media/saint-malo6.aa1ae3fb.jpg";